export const CHECKOUT_URL_AUTOSTART_PARAM = 'startYattaCheckout';
